/** @file Paint-weights tool registration (ToolDef): title and one activation chord (viewport context). */
import type { ToolDef } from '../../stores/types';

/** KeyP activates the tool (R-E1-17 leaves T and P to E5); pointer behaviour is paintWeightsPointer in toolPointers. */
export const tool: ToolDef = { id: 'paintWeights', title: 'tools.paintWeights.title', bindings: [{ id: 'tool.paintWeights', keys: 'KeyP', context: 'viewport' }] };
